import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { I18nProvider } from "@/lib/i18n";
import LangLayout from "@/components/LangLayout";
import ScrollToTop from "@/components/ScrollToTop";
import CookieBanner from "@/components/CookieBanner";
import Home from "@/pages/Home";
import LegalPage from "@/pages/LegalPage";
import ThankYou from "@/pages/ThankYou";

function App() {
  return (
    <div className="App min-h-screen bg-[#F8F9FA] text-[#1B263B]">
      <BrowserRouter>
        <I18nProvider>
          <ScrollToTop />
          <Routes>
            <Route path="/" element={<Navigate to="/ar" replace />} />
            <Route path="/thank_you" element={<ThankYou />} />
            <Route path="/:lang" element={<LangLayout />}>
              <Route index element={<Home />} />
              <Route
                path="privacy"
                element={<LegalPage pageKey="privacy" testId="privacy-page" />}
              />
              <Route
                path="cookies"
                element={<LegalPage pageKey="cookies" testId="cookies-page" />}
              />
              <Route
                path="terms"
                element={<LegalPage pageKey="terms" testId="terms-page" />}
              />
            </Route>
            <Route path="*" element={<Navigate to="/ar" replace />} />
          </Routes>
          <CookieBanner />
        </I18nProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
